var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"booking"},[_c('div',{staticClass:"container mx-auto"},[_c('reserve-same-appointment-failed'),(_vm.currentTab === 'details')?_c('patient-details'):_vm._e(),(_vm.currentTab === 'injury')?_c('injury-details'):_vm._e(),(_vm.currentTab === 'payment')?_c('payment-details'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }